import React, { useState, useEffect } from "react";
import { Stack } from "@mui/material";
import CustomTab from "./CustomTab";

const TabsComponent = ({
  value = "1",
  setValue = () => {},
  tabs = [],
  selectedBackgroundColor = "#007BFF",
  unselectedBackgroundColor = "rgba(0, 123, 255, 0.63)",
  selectedTextColor = "#FFFFFF",
  unselectedTextColor = "white",
}) => {
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 775);

  const handleResize = () => {
    setIsLargeScreen(window.innerWidth > 775);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <Stack direction="row">
      {tabs.map((item, index) => {
        const isSelected = value === item.key;
        return (
          <CustomTab
            key={item.key}
            label={item.label}
            selected={isSelected}
            onClick={() => handleChange(item.key)}
            backgroundColor={
              isSelected ? selectedBackgroundColor : unselectedBackgroundColor
            }
            color={isSelected ? selectedTextColor : unselectedTextColor}
            index={index}
          />
        );
      })}
    </Stack>
  );
};

export default TabsComponent;
